export const EMAIL_REQUIRED_MESSAGE = "Email address is required";

export const EMAIL_INVALID_MESSAGE = "Please enter a valid email address";

export const PHONE_REQUIRED_MESSAGE="Contact is required"

export const PHONE_INVALID_MESSAGE="Please provide valid contact"

export const PASSWORD_REQUIRED_MESSAGE = "Password is required";

export const MESSAGE_REQUIRED="Message is required"

export const    MIN_LENGTH_ONE_CHARACTERS =
  "Please provide a minimum of 1 character";

export const FIRST_NAME_REQUIRED_MESSAGE = "First Name is required";

export const MIN_LENGTH_TEN ="Please provide a minimum of 10 characters";

export const MIN_LENGTH_VALIDATE_MESSAGE = "Please provide a minimum of 2 characters";

export const MAX_LENGTH_VALIDATE_MESSAGE = "Please provide a maximum of 60 characters only"

export const MAX_LENGTH_TWO_FIFTY = "Please provide a maximum of 250 characters only";

export const MAX_LENGTH_FIVE_THOUSAND = "Please provide a maximum of 5000 characters only";

export const MAX_LENGTH_FIVE_HUNDRED= "Please provide a maximum of 500 characters only";


export const MAX_LENGTH_THOUSAND = "Please provide a maximum of 1000 characters only";
export const END_DATE_REQUIRED_MESSAGE = "Please provide a maximum of 1000 characters only";

export const MAX_LENGTH_HUNDRED = "Please provide a maximum of 100 characters only";

export const LAST_NAME_REQUIRED_MESSAGE = "Last Name is required";

export const FIRST_NAME_INVALID_MESSAGE ="Please provide valid First Name";

export const LAST_NAME_INVALID_MESSAGE = "Please provide valid Last Name";



export const CITY_REQUIRED_MESSAGE = "City is required";

export const CITY_INVALID_MESSAGE = "Please provide valid city name";

export const MAX_LENGTH_TWENTY_MESSAGE = "Please provide 20 characters only";

export const STATE_REQUIRED_MESSAGE = "State is required";

export const STATE_INVALID_MESSAGE = "Please provide valid state";

export const ZIPCODE_REQUIRED_MESSAGE = "Zip code is required";

export const ZIPCODE_INVALID_MESSAGE = "Please provide valid zipcode";

export const ZIPCODE_MIN_LENGTH_MESSAGE = "Please provide minimum 5 digits";

export const ZIPCODE_MAX_LENGTH_MESSAGE = "Please provide a maximum of 5 digits";    

export const CONTACT_REQUIRED_MESSAGE = "Contact is required";


export const DATE_OF_BIRTH_REQUIRED_MESSAGE = "Date of birth is required";

export const DEGREE_REQUIRED_MESSAGE = "Qualification is required";

export const GENDER_REQURIED_MESSAGE="Gender is required"
